module.exports = __webpack_public_path__ + "static/media/pipes_tata.62766b24.jpeg";